"use strict";
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = require("@firebase/util");
var util_2 = require("../util/util");
var StatsListener_1 = require("./StatsListener");
// Assuming some apps may have a short amount of time on page, and a bulk of firebase operations probably
// happen on page load, we try to report our first set of stats pretty quickly, but we wait at least 10
// seconds to try to ensure the Firebase connection is established / settled.
var FIRST_STATS_MIN_TIME = 10 * 1000;
var FIRST_STATS_MAX_TIME = 30 * 1000;
// We'll continue to report stats on average every 5 minutes.
var REPORT_STATS_INTERVAL = 5 * 60 * 1000;
/**
 * @constructor
 */
var StatsReporter = /** @class */ (function () {
 /**
 * @param collection
 * @param server_
 */
 function StatsReporter(collection, server_) {
 this.server_ = server_;
 this.statsToReport_ = {};
 this.statsListener_ = new StatsListener_1.StatsListener(collection);
 var timeout = FIRST_STATS_MIN_TIME +
 (FIRST_STATS_MAX_TIME - FIRST_STATS_MIN_TIME) * Math.random();
 util_2.setTimeoutNonBlocking(this.reportStats_.bind(this), Math.floor(timeout));
 }
 StatsReporter.prototype.includeStat = function (stat) {
 this.statsToReport_[stat] = true;
 };
 StatsReporter.prototype.reportStats_ = function () {
 var _this = this;
 var stats = this.statsListener_.get();
 var reportedStats = {};
 var haveStatsToReport = false;
 util_1.forEach(stats, function (stat, value) {
 if (value > 0 && util_1.contains(_this.statsToReport_, stat)) {
 reportedStats[stat] = value;
 haveStatsToReport = true;
 }
 });
 if (haveStatsToReport) {
 this.server_.reportStats(reportedStats);
 }
 // queue our next run.
 util_2.setTimeoutNonBlocking(this.reportStats_.bind(this), Math.floor(Math.random() * 2 * REPORT_STATS_INTERVAL));
 };
 return StatsReporter;
}());
exports.StatsReporter = StatsReporter;

//# sourceMappingURL=StatsReporter.js.map



//////////////////
// WEBPACK FOOTER
// ../database/dist/cjs/src/core/stats/StatsReporter.js
// module id = 100
// module chunks = 0